import React, { useState, useEffect, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import Loading from '../../../../Loading/loading';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { AuthContext } from "../../../../Header/auth - context";
import { useSelector } from "react-redux";

const Odsustva = ({ employeeVacationDB, prepareForUpdate }) => {
  const { t } = useTranslation();
  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const company = useSelector(state => state.company);
  const [selectedRowId , setSelectedRowId] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);

const getId = (row) => (row?.id ?? row?.OdsustvoId ?? null);
  const isSelected = (row) => String(getId(row)) === String(selectedRowId);

  const changeStateVacation = (row) => {
    const id = getId(row);
    setSelectedRowId((prev) => {
      const next = String(prev) === String(id) ? null : String(id);
      if (next !== null) {
        // selektovano
        prepareForUpdate(id, row.OdsustvoId, row.datum_od, row.datum_do, false);
      } else {
        // deselektovano
        prepareForUpdate(null, null, null, null, true);
      }
      return next;
    });
  };

  // Dugme u poslednjoj koloni – label zavisi samo od TOG reda
  const buttonChooseVacation = (rowData) => {
    const selected = isSelected(rowData);
    return (
      <Button
        key={getId(rowData)}                // olakša rerender
        size="small"
        label={selected ? "Otkaži" : "Izaberi"}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();              // da klik na dugme ne gađa klik reda
          changeStateVacation(rowData);
        }}
      />
    );
  };


  return (
    <div id="zaposleni_dokumenti">
      <Toast ref={toast} />
      <div className="zaposleni_table">
        <DataTable
          className="stavke-tabela"
          header={(
            <div className="export-buttons fakture-stavke-header">
              <span />
              <input type="search" className="p-inputtext p-component"
                     onInput={(e) => setGlobalFilter(e.target.value)}
                     placeholder={t('common.search')} />
            </div>
          )}
          value={employeeVacationDB}
          paginator
          rows={10}
          first={first}
          globalFilter={globalFilter}
          onPage={(e) => setFirst(e.first)}
          rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
          onRowClick={(e) => changeStateVacation(e.data)}
        >
          <Column field="Naziv" header={t('admin.naziv')}></Column>
          <Column field="Odsustvo" header={t('admin.odsustvo')} sortable></Column>
          <Column field="datum_od" header={t('admin.odCaps')} sortable></Column>
          <Column field="datum_do" header={t('admin.do_')} sortable></Column>
          <Column field="UnetDatuma" header={t('nova.kreiran')}></Column>
          <Column body={buttonChooseVacation} header={t('common.choose')}></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default Odsustva;
